export default __webpack_public_path__ + "static/flowers-7a4ec93e6e5f5fda807622e1aaf8d881.png";